module.exports = __webpack_public_path__ + "img/bd(6).5bf38a6d.png";